import { useLang } from "../../App";

export const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  const row = (key) => (
    <div key={key} className="flex items-center gap-10 shrink-0">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className={i === 0 ? "text-[#fbbf24] font-bold" : ""}>{item}</span>
          <span>•</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className="py-4 bg-[#0a1428] border-b border-[#1e293b] overflow-hidden" data-testid="marquee-strip">
      <div className="mq items-center gap-10 mono text-xs uppercase tracking-[0.2em] text-slate-400">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
